module.exports = __webpack_public_path__ + "static/media/eyk-borderless.217f34e6.png";